// import React, { useState, useEffect } from "react";
// import "./Modals.css";
// import { useNavigate, useParams } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchTimerVal } from "../../feature/actions/timerActions";
// import { Helmet } from "react-helmet";
// import AdsComponent from "../../AdsComponent/AdsComponent";

// const AdsModalForInstitute = ({
//   setTime,
//   show,
//   close,
//   adsval,
//   comesFrom,
//   state,
//   fornavigate,
//   functionForClose,
//   selectedcoursesemester,
//   coursetypeselectedsemester,
//   subjects,
//   optionForPdfData,
//   subjectName,
//   selectedPdfName,
// }) => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const {
//     institute,
//     InstituteId,
//     courses,
//     sem,
//     courseType,
//     subject,
//     modulee,
//     pdf,
//   } = useParams();
//   const { timerData } = useSelector((state) => state?.timers);
//   useEffect(() => {
//     dispatch(fetchTimerVal());
//   }, []);

//   const [timeleft, setTimeleft] = useState(parseInt(timerData?.timing) || 3);
//   const [title, setTitle] = useState("");
//   useEffect(() => {
//     setTimeleft(parseInt(timerData?.timing));
//   }, [timerData]);

//   // let pathValue = state?.institute;
//   // let institutePath = pathValue?.replaceAll(" ", "-");
//   // let coursesPath =state?.course?.replaceAll(" ", "-");
//   // let Path = subjectName?.replaceAll(" ", "-");
//   //semester logics for removing slash
//   // let semesterArr = state?.semester?.split('');

//   // for (let i = 0; i<semesterArr?.length; i++) {
//   //   if (semesterArr[i] === "/") {
//   //     semesterArr[i] = "";
//   //   }
//   // }
//   // let semesterName = semesterArr?.join("");
//   // let semesterNamePath = semesterName?.replaceAll(" ", "-");
//   // let coursesTypePath = state?.coursetype?.replaceAll(" ", "-");
//   // let pdfOptionNamePath = selectedPdfName?.replaceAll(" ", "-");

//   const { addVal } = useSelector((state) => state.adsReducer);

//   useEffect(() => {
//     setTime(timeleft);
//   }, []);

//   useEffect(() => {
//     if (timeleft === 0) {
//       setTimeleft(null);

//       close();
//       if (fornavigate === "From-pdflink") {
//         // navigate("/pdfforinstitute", {

//         navigate(
//           `/${institute}/${InstituteId}/${courses}/${sem}/${courseType}/${subject}/${modulee}/${pdf}`,
//           {
//             state: {
//               institute: institute,
//               course: courses,
//               coursetype: courseType,
//               bookname: subject,
//               semester: sem,
//               module: modulee,
//               // subjectName: subjectName,
//             },
//           }
//         );
//       }
//     }

//     if (!timeleft) return;

//     const intervalId = setInterval(() => {
//       setTimeleft(timeleft - 1);
//       setTime(timeleft - 1);
//     }, 1000);

//     return () => {
//       clearInterval(intervalId);
//     };
//   }, [timeleft, fornavigate]);

//   if (adsval === "0" || addVal === "0") {
//     close();
//   }

//   const handleOverlayClick = (e) => {
//     e.stopPropagation();
//   };

//   return (
//     <>
//       {adsval === "1" && addVal === "1"
//         ? show && (
//           <>
//             <div className="modalContainer">
//               <div
//                 className="modal_show"
//                 onClick={(e) => e.stopPropagation()}
//               >
//                 <AdsComponent dataAdSlot="2597424317" />
//                 <footer className="modal_footer">
//                   <div className="model_button">
//                     <button
//                       className="modal-close"
//                       style={{ color: "black" }}
//                       onClick={() => {
//                         close();
//                         functionForClose(
//                           selectedcoursesemester,
//                           coursetypeselectedsemester,
//                           subjects,
//                           optionForPdfData
//                         );
//                       }}
//                     >
//                       Close
//                     </button>
//                   </div>
//                   {timeleft != null && (
//                     <h3 style={{ color: "black" }}>
//                       00:{timeleft < 10 ? "0" + timeleft : timeleft}
//                     </h3>
//                   )}
//                 </footer>
//               </div>
//             </div>
//             <div className="modal_overlay" onClick={handleOverlayClick} />
//           </>
//         )
//         : null}
//     </>
//   );
// };

// export default AdsModalForInstitute;
import React, { useState, useEffect } from "react";
import "./Modals.css";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchTimerVal } from "../../feature/actions/timerActions";
import { Helmet } from "react-helmet";
import AdsComponent from "../../AdsComponent/AdsComponent";
import axios from "axios";

const AdsModalForInstitute = ({
  setTime,
  show,
  close,
  state,
  fornavigate,
  functionForClose,
  selectedcoursesemester,
  coursetypeselectedsemester,
  subjects,
  optionForPdfData,
  subjectName,
  selectedPdfName,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    institute,
    InstituteId,
    courses,
    sem,
    courseType,
    subject,
    modulee,
    pdf,
  } = useParams();

  const { timerData } = useSelector((state) => state?.timers);

  const [timeleft, setTimeleft] = useState(parseInt(timerData?.timing) || 3);
  const [adsSettings, setAdsSettings] = useState(null);
  const [shouldShowAd, setShouldShowAd] = useState(false);

  useEffect(() => {
    dispatch(fetchTimerVal());
  }, []);

  useEffect(() => {
    setTimeleft(parseInt(timerData?.timing));
  }, [timerData]);

  useEffect(() => {
    setTime(timeleft);
  }, []);

  useEffect(() => {
    const getAdsValue = async () => {
      try {
        const res = await axios.get(
          "https://rollingnotes.in/app/backend/api_v2/ads_setting.php"
        );
        if (res.status === 200) {
          const data = res.data;
          setAdsSettings(data);

          if (data.ads === "1") {
            setShouldShowAd(true);
          } else {
            setShouldShowAd(false);
            close();
          }
        }
      } catch (err) {
        console.error("Error fetching ad settings:", err);
        setShouldShowAd(false);
        close();
      }
    };

    getAdsValue();
  }, []);
  

  useEffect(() => {
    if (timeleft === 0) {
      setTimeleft(null);
      close();

      if (fornavigate === "From-pdflink") {
        navigate(
          `/${institute}/${InstituteId}/${courses}/${sem}/${courseType}/${subject}/${modulee}/${pdf}`,
          {
            state: {
              institute: institute,
              course: courses,
              coursetype: courseType,
              bookname: subject,
              semester: sem,
              module: modulee,
            },
          }
        );
      }
    }

    if (!timeleft) return;

    const intervalId = setInterval(() => {
      setTimeleft(timeleft - 1);
      setTime(timeleft - 1);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [timeleft, fornavigate]);

  const handleOverlayClick = (e) => {
    e.stopPropagation();
  };

  const formattedTime =
    timeleft != null
      ? `${String(Math.floor(timeleft / 60)).padStart(2, "0")}:${String(
        timeleft % 60
      ).padStart(2, "0")}`
      : "00:00";

  return (
    <>
      {shouldShowAd && show ? (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.9)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }} onClick={handleOverlayClick}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '8px',
            boxShadow: '0 4px 16px rgba(0, 0, 0, 0.4)',
            width: '90%',
            maxWidth: '550px',
            padding: '20px'
          }} onClick={(e) => e.stopPropagation()}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '400px', // Increased from 300px to 400px
                border: '1px dashed #ccc',
                backgroundColor: 'white',
                marginBottom: '20px',
                position: 'relative'
              }}>
                <AdsComponent dataAdSlot="2597424317" />
                <div style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  color: '#666',
                  fontSize: '24px',
                  zIndex: 0
                }}>Ad</div>
              </div>
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                paddingTop: '10px'
              }}>
                <button
                  style={{
                    padding: '8px 16px',
                    backgroundColor: '#f5f5f5',
                    border: '1px solid #ddd',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontWeight: 500
                  }}
                  onClick={() => {
                    close();
                    functionForClose(
                      selectedcoursesemester,
                      coursetypeselectedsemester,
                      subjects,
                      optionForPdfData
                    );
                  }}
                >
                  Close
                </button>
                <div style={{ fontSize: '18px', fontWeight: 'bold' }}>{formattedTime}</div>
              </div>
            </div>
          </div>
        </div>
      ) : ""}
    </>
  );
};

export default AdsModalForInstitute;